import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DeleteExportMetadataForAssetMutationVariables = Types.Exact<{
  assetId: Types.Scalars['ID']['input'];
  sequenceId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DeleteExportMetadataForAssetMutation = { __typename?: 'Mutation', deleteExportMetadataForAsset?: { __typename?: 'PremiereSequence', id?: string | null, metadata?: Array<{ __typename?: 'SequenceExportsXMPMetadata', exportedAt: number, assetId: string, versionId?: string | null, shareId?: string | null, projectId: string, accountId: string, sequenceId?: string | null, sequenceIn?: number | null, sequenceOut?: number | null } | { __typename?: 'V3PanelExportsXMPMetadata' } | { __typename?: 'V4CommentsPanelExportsXMPMetadata', exportedAt: number, shareId?: string | null } | null> | null } | null };


export const DeleteExportMetadataForAsset = /*#__PURE__*/ gql`
    mutation DeleteExportMetadataForAsset($assetId: ID!, $sequenceId: ID) {
  deleteExportMetadataForAsset(assetId: $assetId, sequenceId: $sequenceId) {
    id
    metadata {
      ... on SequenceExportsXMPMetadata {
        exportedAt
        assetId
        versionId
        shareId
        projectId
        accountId
        sequenceId
        sequenceIn
        sequenceOut
      }
      ... on V4CommentsPanelExportsXMPMetadata {
        exportedAt
        shareId
      }
    }
  }
}
    ` as unknown as DocumentNode<DeleteExportMetadataForAssetMutation, DeleteExportMetadataForAssetMutationVariables>;

          

          export const useDeleteExportMetadataForAssetMutation = (options?:MutationHookOptions<DeleteExportMetadataForAssetMutation, DeleteExportMetadataForAssetMutationVariables>) => useMutation(DeleteExportMetadataForAsset, options);
          

          export type DeleteExportMetadataForAssetMutationOptions = MutationHookOptions<DeleteExportMetadataForAssetMutation, DeleteExportMetadataForAssetMutationVariables>;

          

          export type DeleteExportMetadataForAssetMutationResult = ReturnType<typeof useDeleteExportMetadataForAssetMutation>[1];

          
